<!--
 * @Desc: 友情链接
   标签类名，使用-进行分割命名，如page-home、item-form
   标签id，使用小驼峰规则命名，如homeId、itemId
   变量名，使用小驼峰规则命名，如publicPath、wxCode
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-08 10:11:39
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-school-link">
        <!-- 菜单 -->
        <menuCommon :active="active"></menuCommon>
        <!-- 内容区 -->
        <section class="school-link">
            <div class="container">
                <div style="height:30px;"></div>
                <div class="link-hold">
                    <el-empty style="width:100%;" description="暂无数据" v-if="linkList && linkList.length == 0"></el-empty>
                    <div class="link-item" @click="toPath(item)" v-for="(item,idx) in linkList" :key="idx">
                        <img class="thu" :src="$adddom(item.thumb)">
                        <h1>{{ item.title }}</h1>
                    </div>
                </div>
            </div>
        </section>
        <!-- 页脚 -->
        <footerCommon></footerCommon>
    </div>
</template>

<script>
import utils from "@/api/Utils.js"
import menuCommon from "./../components/Common/Menu.vue";
import footerCommon from "./../components/Common/Footer.vue";
import BreadCrumb from "./../components/Common/BreadCrumb.vue";
import RecommendedRead from "./../components/Common/RecommendedRead.vue";
import MenuVertical from "./../components/Common/MenuVertical.vue";
import LastRecommend from "./../components/Common/LastRecommend.vue";
export default {
    name: "home",
    data() {
        return {
            // 菜单选中
            active: this.$route.query.active,
            linkList:''
        };
    },
    components: {
        menuCommon,
        footerCommon,
        BreadCrumb,
        RecommendedRead,
        MenuVertical,
        LastRecommend,
    },
    watch:{
        $route(val){
        }
    },
    created() {
        this.getLink()
    },
    mounted() {
        $("html,body").scrollTop(0);
    },
    beforeDestroy() {},
    methods: {
        // 跳转到链接
        toPath(item){
            if(item.url) {
                window.open(item.url)
            }
        },
        // 获取友情链接
        getLink(){
            let that = this
            that.$api.index.link({}).then((res) => {
                if (res.code == 200) {
                    // console.log(res)
                    that.linkList = res.result
                }
            })
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-school-link {
    background: #f0f2f5 no-repeat top center;
}
/*  */
.page-school-link .school-link .container .link-hold {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    overflow: hidden;
    margin-bottom: 30px;
    background: #fff;
    padding-bottom: 30px;
    padding-left: 48px;
}
.page-school-link .link-hold .link-item{
    margin-right: 48px;
    margin-top: 30px;
}
.page-school-link .link-hold .link-item:nth-child(5n){
    margin-right: 0px;
}
.page-school-link .link-hold .link-item .thu{
    width: 240px;
    height: 74px;
    background-color: #f0f2f5;
    object-fit: scale-down;
}
.page-school-link .link-hold .link-item h1{
    font-size: 14px;
    text-align: center;
    margin-top: 5px;
}
</style>